class CustomProductInfo extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $(this).css({"opacity":"1"});
        document.querySelectorAll('[data-sectionid]').forEach(section => {
            const id = section.getAttribute('data-sectionid');
            const container = section.querySelector(`.featured-product-swiper-${id}`);
            if (!container) return;

            new Swiper(container, {
                slidesPerView: 1,
                spaceBetween: 2,
                scrollbar: {
                el: container.querySelector('.swiper-scrollbar'),
                hide: false,
                draggable: true,
              },
                breakpoints: {
                    640: { 
                        slidesPerView: 1,
                        spaceBetween: 2,
                    },
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 2,
                        scrollbar: {
                        el: container.querySelector('.swiper-scrollbar'),
                        hide: true,
                        draggable: true,
                      },
                    },
                },
                navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            });
        });

    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-product-info", CustomProductInfo);

$(document).ready(function(){
  $('.proceed-button-checkout').unbind().click(function(){
    $('.dialog-modal[open]').click();
    $('.custom-cart-popup-container').css({"display":"block"});
  });
});


